
export const alertXinLoi =()=>{
    alert('Xin lỗi, tính năng này đang được bảo chì!')
}